<template>
   <div id="accordion-layer">
      <el-collapse accordion v-model="currentActiveGroupId">
         <layer-group
            v-for="(category,index) in getGUILayersInfo"
            :category="category"
            :key="category.title"
            :showByDefault="index===0"
         />
      </el-collapse>
  </div>
  
</template>

<script>
import LayerGroup from '../../../organisms/Home/LayerGroup';
import { Collapse } from 'element-ui';

import { mapGetters } from 'vuex';

export default {
   name: 'layers-sidebar',
   components: {
      LayerGroup,
      'el-collapse': Collapse,
   },
   computed: {
      ...mapGetters('layers', ['getGUILayersInfo']),
   },
   data()
   {
      return {
         currentActiveGroupId: 6, 
      };
   }
};
</script>

<style lang="scss" scoped>
#accordion-layer {
   margin: 4px;
}
</style>